// Estado vacio aprobado ("Bandeja que se despeja"): sol con rayos que giran sobre un buzon. Los colores salen de
// los tokens del tema, asi se ve bien en claro, oscuro y con cualquier paleta.
import { useId, type ReactNode } from 'react';

export function BandejaDespejada({ titulo = 'Bandeja despejada', texto = 'No te queda nada por responder.', children }: { titulo?: string; texto?: string; children?: ReactNode }) {
  const id = useId().replace(/:/g, '');
  return (
    <div className="band-vacia" role="status">
      <svg viewBox="0 0 200 150" aria-hidden="true">
        <defs>
          <linearGradient id={`sol-${id}`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" className="sol-a" />
            <stop offset="1" className="sol-b" />
          </linearGradient>
        </defs>
        <g className="rayos">
          {Array.from({ length: 12 }, (_, i) => {
            const a = (i / 12) * Math.PI * 2;
            return <line key={i} x1={100} y1={56} x2={100 + 54 * Math.cos(a)} y2={56 + 54 * Math.sin(a)} />;
          })}
        </g>
        <circle cx={100} cy={56} r={28} fill={`url(#sol-${id})`} className="sol" />
        <ellipse cx={100} cy={132} rx={70} ry={9} className="suelo" />
        <rect x={97} y={118} width={6} height={16} className="poste" />
        <rect x={74} y={80} width={52} height={42} rx={20} className="buzon" />
        <rect x={84} y={96} width={22} height={4} rx={2} className="ranura" />
        <path d="M124 86 l14 -8 v14 z" className="bandera" />
      </svg>
      <h3>{titulo}</h3>
      <p>{texto}</p>
      {children}
    </div>
  );
}
